const SLOT_STATUS = {
  TIMEOUT: "timeout",
  SUCCESS: "success",
  FAIL: "fail",
  ACTIVE: "active",
  EMPTY: "empty",
};

export default SLOT_STATUS;
